import {IForm} from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'corpId',
      type: 'default',
      label: '所属主体ID',
      isDisabled: true,
      isHidden: true
    },
    {
      field: 'corpName',
      type: 'default',
      label: '所属主体',
      isDisabled: true
    },
    {
      field: 'handoverUserid',
      type: 'default',
      label: '转移账号',
      isDisabled: true
    },
    {
      field: 'externalUserid',
      type: 'default',
      label: '客户ID',
      isHidden: true,
      isDisabled: true
    },
    {
      field: 'externalUsername',
      type: 'default',
      label: '转移客户',
      isDisabled: true
    },
    {
      field: 'takeoverUserid',
      type: 'input',
      label: '承接账号'
    },
    {
      field: 'transferSuccessMsg',
      type: 'textarea',
      label: '发送的消息'
    },
    {
      field: 'transferType',
      type: 'default',
      label: '转移类型',
      isHidden: true
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
